export interface SendMessageInterface {
    attachment_file?: File | Blob | string | null;
    sender_id: number;
    chat_id: string | null;
    text?: string | undefined;
    user_id: string;
    type?: string;
    chat_type?: string;
    status?: string;
    timestamp?: number;
}

export const API_URL = `${process.env.REACT_APP_SOCKET_TLS}://${process.env.REACT_APP_SOCKET_HOST}`;
export const apiToken = (() => localStorage.getItem('api_token'))();
export const AUTH_TOKEN = () => apiToken as string;

export const getChatEnv = (): string => {
    const env = process.env.REACT_APP_ENV;
    const host = (process.env.REACT_APP_SOCKET_HOST ?? '').toLowerCase();

    // Если база/хост продовые, но env по ошибке "testing" — для чата нужен production-префикс.
    if (env === 'testing' && host && !host.includes('testing') && !host.includes('demo')) {
        return 'production';
    }

    return env || 'production';
};

export const getUserId = (userId: string | number | null | undefined = null) =>
    `${getChatEnv()}-${userId ?? localStorage.getItem('user_id')}`;

export const getCommonHeaders = (authorization: string, userId: string | null) => {
    return {
        Authorization: authorization,
        UserId: userId ?? '',
        'Content-Type': 'application/json',
    };
};

